import { Route, Routes, useParams } from 'react-router-dom';

import { useJourneyEnhancedNavigation } from '@/store/v2/journeys/useJourneyEnhancedNavigation';
import {
  LockedLearningWarningModal,
  useLockedLearningWarningModalProps,
} from '@/administration/pages/Journey/common/modals/LockedLearningWarningModal';
import { SurveyStart } from '@/features/course/learner/pages/SurveyStart';
import { LayoutWrapper } from '@/component/App/component/LayoutWrapper/LayoutWrapper';
import { SurveyView } from '@/features/course/learner/pages/SurveyView';
import { useSurveyViewer } from '@/features/course/learner/hooks/useSurveyViewer';

export const Survey = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();

  const parsedSurveyId = id ? parseInt(id) : NaN;

  const props = useSurveyViewer(Number(id));

  const { currentItem, journeyTitle, journeyId, nextItem, allUpcomingItemsLocked, allUpcomingItemsUnlockAt } =
    useJourneyEnhancedNavigation({
      id: parsedSurveyId,
    });

  const learningLockedModalProps = useLockedLearningWarningModalProps({
    parentJourneyId: journeyId,
    parentJourneyTitle: journeyTitle,
    isCurrentItemLock: currentItem?.isLocked,
  });

  return (
    <>
      {learningLockedModalProps && <LockedLearningWarningModal {...learningLockedModalProps} />}
      <Routes>
        <Route
          path="/"
          element={
            <LayoutWrapper>
              <SurveyStart
                {...props}
                nextItem={nextItem || undefined}
                allUpcomingItemsLocked={allUpcomingItemsLocked}
                allUpcomingItemsUnlockAt={allUpcomingItemsUnlockAt}
              />
            </LayoutWrapper>
          }
        />
        <Route path="/view/*" element={<SurveyView {...props} />} />
      </Routes>
    </>
  );
};
